import { generateAvatarList } from './generator'

/**
 * Avatar list for school classes.
 * Currently uses the default avatar path, but can be customized in the future
 * when school-class-specific assets are available.
 *
 * To customize when assets are ready:
 * generateAvatarList({ pathPrefix: 'avatar/school-class/' })
 */
export const schoolClassAvatarList = generateAvatarList()
